import { Box, Flex } from "@chakra-ui/react";
import { H4, Subtitle2 } from "src/atoms/typography";
import IconOnBackground from "src/components/IconOnBackground";
import colors from "src/modules/command/colors";
import icons from "src/modules/command/commands-icons";

export default function CommandPreview({ t, command }) {
  const { name, color, icon } = command;
  return (
    <Box>
      <H4 color="highEmphasis" mb="8px">
        {t("command.editor.preview")}
      </H4>
      <Flex flexDirection="column">
        <IconOnBackground
          icon={icons[icon].icon}
          bg={colors[color].name}
          fill="white"
          size="40px"
          iconSize="20px"
        />
        <Subtitle2 color="mediumEmphasis" mt="6px">
          {name ? name : t(`command.name.${icons[icon].name}`)}
        </Subtitle2>
      </Flex>
    </Box>
  );
}
